import { namespacer } from 'helpers'

const namespace = namespacer('NON_FSP_SESSION_SALE')
export const LOAD_UPDATED_SESSION_SALE = namespace('LOAD_UPDATED_SESSION_SALE')
